import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M17.76,21.56a7.43,7.43,0,0,1-5.26-2.18,2,2,0,1,1,2.83-2.83,3.53,3.53,0,0,0,4.87,0l4.67-4.67A3.44,3.44,0,1,0,20,7L18.08,8.93a2,2,0,0,1-2.83-2.82l1.92-1.93A7.45,7.45,0,1,1,27.7,14.71L23,19.38A7.44,7.44,0,0,1,17.76,21.56Z"/><path d="M9.32,30A7.45,7.45,0,0,1,4.06,17.29l4.67-4.67a7.46,7.46,0,0,1,10.53,0,2,2,0,0,1-2.83,2.83,3.53,3.53,0,0,0-4.87,0L6.89,20.12A3.44,3.44,0,0,0,11.76,25l1.92-1.92a2,2,0,0,1,2.83,2.82l-1.92,1.93A7.44,7.44,0,0,1,9.32,30Z"/>';
export var LinkSVG = function LinkSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
LinkSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LinkSVG);